/**
* Story card directive
* @author Ryan Gladstone
*/

import template from './taskCard.html';
import TaskCardController from './TaskCardController';

function taskCardDir() {
  return {
    restrict: 'E',
    scope: {
      task: '=',
      filterSet: '=',
      removeTaskFromResults: '&'
    },
    template,
    controller: 'TaskCardController'
  };
}

export default function (ngModule) {
  ngModule.directive('taskCard', taskCardDir);
  TaskCardController(ngModule);
}
